<template>
    <ToggleSimple v-if="companies?.length" :default="true" cssClass="toggle-type-2">
        <template #toggle>
            <div class="left">
                <div class="toggle-text">
                    {{ $t(`components.dataset_specification.examples.name`) }}
                </div>
                <div class="toggle-description">
                    {{ $t(`components.dataset_specification.examples.description`) }}
                </div>
            </div>
            <div class="right">
                <div class="toggle-icon"></div>
            </div>
        </template>

        <template #content>
            <ExamplesTable />
        </template>
    </ToggleSimple>
</template>

<script>
    import { mapState } from 'pinia';
    import { useDatasetStore } from '@/stores/dataset';
    import ToggleSimple from '@/components/elements/misc/ToggleSimple';
    import ExamplesTable from '@/components/builder/misc/ExamplesTable';

    export default {
        name: 'SpecificationExamples',
        components: {
            ToggleSimple,
            ExamplesTable
        },
        computed: {
            ...mapState(useDatasetStore, ['dataset', 'companies'])
        },
        methods: {}
    }
</script>